"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherCodeSchema = exports.UrlSchema = exports.DateTimeStringSchema = exports.PriceStringSchema = exports.ItemCountSchema = exports.CoercedNumericIdSchema = exports.NumericIdSchema = void 0;
const zod_1 = require("zod");
exports.NumericIdSchema = zod_1.z.number().int().positive();
// For use in query where express gives us a string, and we have to make a lemonade
exports.CoercedNumericIdSchema = zod_1.z.coerce.number().int().positive();
exports.ItemCountSchema = zod_1.z.number().int().nonnegative().min(0);
exports.PriceStringSchema = zod_1.z
    .string()
    .regex(/^\d+\.\d{2}$/, {
    message: 'PriceString must be a valid number with two decimal places',
})
    .openapi({ example: '900.00', examples: ['12.34', '850.00', '0.00'] });
exports.DateTimeStringSchema = zod_1.z.string().datetime({ offset: true });
exports.UrlSchema = zod_1.z.string().url().openapi({ example: 'https://example.com' });
exports.VoucherCodeSchema = zod_1.z.string().openapi({ example: 'GIRLPOWER' });
